import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { inject } from 'vue';
import { IKRightDrawer } from './RightDrawer.InjectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'RightDrawer',
  setup(__props) {

const rightDrawer = inject(IKRightDrawer);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Right-drawer-container", { closed: !_unref(rightDrawer)?.drawer.value.component }])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(rightDrawer)?.drawer.value.component as any), _mergeProps({ class: "full-height column items-center" }, _unref(rightDrawer)?.drawer.value.props), null, 16))
  ], 2))
}
}

})